const Imagine = () => {
    return (
        <section id="imagine">
            <div className="container-fluid pt-4 pb-4 text-center gg-bg-solid-green-light">
                <div className="row align-items-center justify-content-center">
                    <div className="col-md-8 col-11">
                        <h3 className="mb-4 fw-bold">Imagine This...</h3>
                        <h5 className="fw-light mb-4">Six months from now:</h5>
                        <h5 className="fw-bold mb-4">You wake up feeling light, energised, and in control.</h5>
                        <h5 className="fw-bold mb-4">You eat the foods you love, without guilt.</h5>
                        <h5 className="fw-bold mb-4">You move through your day without that constant fear of spikes, crashes, or cravings.</h5>
                        <h3 className="fw-bold mb-4">And it all started... because you said yes today.</h3>
                        <h5 className="fw-light mb-4">Because you were one of the lucky few who received this rare opportunity and didn’t let it slip through your fingers.</h5>
                        <h5 className="fw-light mb-4">Not everyone gets this chance.</h5>
                        <h5 className="fw-light mb-4">You’re already ahead of the curve.<br />You said yes to change.<br />Now say yes to lasting results! </h5>
                        <h5 className="fw-bold mb-4">Click below to finish your order, secure your 6-month supply at our lowest price ever, and reclaim the health that was always waiting for you.</h5>
                    </div>
                </div>
                <div className="row justify-content-center text-center">
                <div className="col-xxl-4 col-lg-5 col-md-7 col-sm-8 col-10 ">
                    <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=glu6u&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9vcHRpdmlzdGEtdQ==" className="text-decoration-none btn gg-button-buy-yellow gg-buy-card-button gg-bigger-button fw-bold text-uppercase gtm-nav-btn" data-gtm-label="GlucoGen Upsell 6 - Imagine - Go To Offer">GET YOUR 6-MONTH SUPPLY NOW</a>
                </div>
            </div>
            </div>
        </section>
    );
};

export default Imagine;